
import {Link} from 'react-router-dom';
import '../../assets/css/breadcrumb.css';
const BreadcrumbSecand = () => {
  return (
    
<section className="breadcrumb-link" style={{ background: "rgb(238, 238, 238)" }}> 
    <div className="container">
      <div className="row mb-4">
        <div className=" col-md-8 col-sm-6 col-12">
          <div className="Filterbg">  
            <h4 className="text-gray-500 text-sm pt-2 font-normal mt-2" style={{ fontSize: "17px" }}><span>Home</span>  </h4>    
          </div>    
        </div>
        <div className="col-md-3 col-sm-6 col-10"> 
          <div className="justify-content-end align-items-center">  
            <div className="input-icon" style={{ marginTop: "4px"}}>  
              <i className="bi bi-search font-sm" style={{ color:"#000"}}></i>
                <input type="text" placeholder="Search..." className="form-control form-control-sm bg-white" style={{ backgroundColor: "#FFF !important", color:"#000 !important"}} />
                    </div>
                  </div> 
              </div>
                <div className='col-md-1 col-2'> 
                      <Link to="/" className="iconmargin">
                            <i className="bi bi-list-task"></i>
                      </Link> </div>
                </div>
           </div>
    </section>
  );
}
export default BreadcrumbSecand;
